// Hook that automatically geofences an app
import axios from "axios";
import { useEffect, useState } from "react";
export var GeofenceCountry;
(function (GeofenceCountry) {
    GeofenceCountry["SINGAPORE"] = "SG";
    GeofenceCountry["US"] = "US";
})(GeofenceCountry || (GeofenceCountry = {}));
export var REarnGeofenceCountry;
(function (REarnGeofenceCountry) {
    REarnGeofenceCountry["BELARUS"] = "BY";
    REarnGeofenceCountry["CUBA"] = "CU";
    REarnGeofenceCountry["NORTHKOREA"] = "KP";
    REarnGeofenceCountry["CONGO"] = "CD";
    REarnGeofenceCountry["IRAN"] = "IR";
    REarnGeofenceCountry["IRAQ"] = "IQ";
    REarnGeofenceCountry["LEBANON"] = "LB";
    REarnGeofenceCountry["LIBYA"] = "LY";
    REarnGeofenceCountry["MALI"] = "ML";
    REarnGeofenceCountry["MYANMAR"] = "MM";
    REarnGeofenceCountry["NICARAGUA"] = "NI";
    REarnGeofenceCountry["RUSSIA"] = "RU";
    REarnGeofenceCountry["SOMALIA"] = "SO";
    REarnGeofenceCountry["SOUTHSUDAN"] = "SS";
    REarnGeofenceCountry["SUDAN"] = "SD";
    REarnGeofenceCountry["SYRIA"] = "SY";
    REarnGeofenceCountry["US"] = "US";
})(REarnGeofenceCountry || (REarnGeofenceCountry = {}));
// and then redirects to a URL if not applicable
export var useGeofence = function (country) {
    // If rejected, redirect to rejectedUrl
    var _a = useState(false), rejected = _a[0], setRejected = _a[1];
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    useEffect(function () {
        setLoading(true);
        axios
            .get("https://ipapi.co/country")
            .then(function (_a) {
            var data = _a.data;
            if (data === country) {
                setRejected(true);
            }
            else {
                setRejected(false);
            }
        })
            .catch(function (e) {
            // Geofence failed. Should we default to rejected or ok?
            setRejected(false);
        })
            .finally(function () {
            setLoading(false);
        });
    }, [country]);
    return {
        rejected: rejected,
        loading: loading,
    };
};
// and then redirects to a URL if not applicable
export var useREarnGeofence = function (countries) {
    // If rejected, redirect to rejectedUrl
    var _a = useState(false), rejected = _a[0], setRejected = _a[1];
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    useEffect(function () {
        setLoading(true);
        axios
            .get("https://ipapi.co/country")
            .then(function (_a) {
            var data = _a.data;
            if (countries.includes(data)) {
                setRejected(true);
            }
            else {
                setRejected(false);
            }
        })
            .catch(function (e) {
            // Geofence failed. Should we default to rejected or ok?
            setRejected(false);
        })
            .finally(function () {
            setLoading(false);
        });
    }, []);
    return {
        rejected: rejected,
        loading: loading,
    };
};
//# sourceMappingURL=useGeofence.js.map